// import Home from "@/views/Home.vue"
import policy from "@/views/policy.vue"
import xuanke from "@/views/xuanke.vue"
import main from "@/views/main.vue"
import details from "@/views/details.vue"
import Gostulocation from "@/views/to/GoStuLocation.vue"
import toProgramme from "@/views/to/toProgramme.vue"
import xingaokao from "@/views/xingaokao.vue"
import XkAdministration from "@/views/XkAdministration.vue"
import newSchoolProgramme from "@/views/newSchoolProgramme.vue"
import toNewSchoolProgramme from "@/views/to/toNewSchoolProgramme.vue"
import XkPreview from "@/views/XkPreview.vue"
import layout from "@/layout"


const routes = [
	{
		path: '/',
		name: 'teacher',
		component: layout,
		redirect: "/main",
		children: [
			{
				path: '/login',
				name: '登录',
				meta: {
					title: '登录'
				},
				component: () => import('@/views/login/index.vue')
			},
			{
				path: '/main',
				name: '首页',
				meta: {
					title: '首页',
          isNavbar: true,
				},
				component: main
			},
      {
				path: '/policy',
				redirect: '/policy/index',
				meta: {
					title: '政策资讯',
					requiresAuth: true,
					keepAlive: true,
          isNavbar: true,
				},
				component: () => import('@/views/router-view.vue'),
				children: [
					{
						path: 'index',
            name: 'PolicyIndex',
						meta: {
							title: '政策资讯',
							requiresAuth: true,
					    keepAlive: true,
						},
						component: () => import('@/views/policy.vue')
					},
          {
						path: 'details',
						meta: {
							title: '政策资讯',
							requiresAuth: true,
						},
						component: () => import('@/views/details.vue')
					},
				]
			},
			{
				path: '/speciality',
				name: '专业解读',
				redirect: '/speciality/majors',
				meta: {
					title: '专业解读',
					requiresAuth: true,
          isNavbar: true,
				},
				component: () => import('@/views/router-view.vue'),
				children: [
					{
						path: 'majors',
						meta: {
							title: '专业解读',
							requiresAuth: true,
						},
						component: () => import('@/views/speciality/majors/index.vue')
					},
					{
						path: 'majorsDetail',
						meta: {
							title: '专业解读',
							requiresAuth: true,
						},
						component: () => import('@/views/speciality/majorsDetail/index.vue')
					},
					{
						path: 'diff',
						meta: {
							title: '专业对比',
							requiresAuth: true,
						},
						component: () => import('@/views/speciality/diff/index.vue')
					},
				]
			},
			{
				path: '/SchoolInformation',
				name: '院校查询',
				meta: {
					title: '院校查询',
					requiresAuth: true,
          isNavbar: true,
				},
				component: () => import('@/views/school/list/indexTeacher.vue')
			},
      {
        path: '/design',
        name: '方案设计',
        redirect: '/design/center',
        meta: {
          title: '方案设计',
          requiresAuth: true,
          isNavbar: false,
        },
        component: () => import('@/views/router-view.vue'),
        children: [
          {
            path: 'center',
            meta: {
              title: '方案设计',
              requiresAuth: true,
            },
            component: () => import('@/views/design/center/index.vue')
          },
          {
            path: 'management',
            meta: {
              title: '方案设计',
              requiresAuth: true,
            },
            component: () => import('@/views/design/management/index.vue')
          },
          {
            name: 'designPreview',
            path: 'preview', // 预览
            meta: {
              title: '方案设计',
              requiresAuth: true,
            },
            component: () => import('@/views/design/preview/index.vue')
          },
          {
            path: 'programme', // 新增|编辑 老师角色
            meta: {
              title: '方案设计',
              requiresAuth: true,
            },
            component: () => import('@/views/design/programme/index.vue')
          },
          {
            path: 'studentProgramme', // 新增|编辑 学生角色
            meta: {
              title: '方案设计',
              requiresAuth: true,
            },
            component: () => import('@/views/design/programme/indexStudent.vue')
          },
          {
            path: 'print',	// 打印
            show: false,
            meta: {
              title: '方案设计'
            },
            component: () => import('@/views/design/print/index.vue')
          },
          {
            path: 'singlePrint', // 列表上的打印
            name: 'designSinglePrint',
            meta: {
              title: '方案设计',
              requiresAuth: true,
            },
            component: () => import('@/views/design/print/singlePrint.vue')
          },
          {
            path: 'stuLocation',
            meta: {
              title: '定位专业',
              requiresAuth: true,
            },
            component: () => import('@/views/design/stuLocation/index.vue')
          },
          {
            path: 'stuArchives',
            meta: {
              title: '建立档案',
              requiresAuth: true,
            },
            component: () => import('@/views/design/stuArchives/index.vue')
          },
          {
            path: 'printStuArchives',
            meta: {
              title: '打印档案',
              requiresAuth: true,
            },
            component: () => import('@/views/design/print/stuArchives.vue')
          },
          {
            path: 'printStuMajor',
            meta: {
              title: '打印专业报告',
              requiresAuth: true,
            },
            component: () => import('@/views/design/print/stuMajor.vue')
          },
          {
            path: 'printStuScheme',
            meta: {
              title: '打印方案',
              requiresAuth: true,
            },
            component: () => import('@/views/design/print/stuScheme.vue')
          },
          {
            path: '/autoGenerate',
            meta: {
              title: '智慧生成',
              requiresAuth: true,
            },
            component: () => import('@/views/designV2/autoGenerate/index.vue')
          },
        ]
      },
			{
				path: '/schoolV2',
				redirect: '/schoolV2/index',
				meta: {
          title: '院校查询(新)',
					requiresAuth: true,
          isNavbar: true,
				},
				component: () => import('@/views/router-view.vue'),
				children: [
					{
						path: 'index',
						meta: {
							requiresAuth: true,
						},
						component: () => import('@/views/schoolV2/list/indexTeacher.vue')
					},
					{
						name: 'schoolV2Detail',
						path: 'detail',
						meta: {
							title: '院校解读',
						},
						component: () => import('@/views/schoolV2/detail/index.vue')
					},
					{
						path: 'schoolDiff',
						meta: {
							title: '院校对比',
						},
						component: () => import('@/views/schoolV2/diff/index.vue')
					},
				]
			},
			{
				path: '/designV2',
				name: '方案设计(新)',
				redirect: '/designV2/center',
				meta: {
					title: '方案设计(新)',
					requiresAuth: true,
          isNavbar: true,
				},
				component: () => import('@/views/router-view.vue'),
				children: [
					{
						path: 'center',
						meta: {
							title: '方案设计(新)',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/center/index.vue')
					},
					{
						path: 'management',
						meta: {
							title: '方案设计(新)',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/management/index.vue')
					},
					{
						name: 'designV2Preview',
						path: 'preview', // 预览
						meta: {
							title: '方案设计(新)',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/preview/index.vue')
					},
					{
						path: 'programme', // 新增|编辑 老师角色
						meta: {
							title: '方案设计(新)',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/programme/index.vue')
					},
					{
						path: 'studentProgramme', // 新增|编辑 学生角色
						meta: {
							title: '方案设计(新)',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/programme/indexStudent.vue')
					},
					{
						path: 'print',	// 打印
						show: false,
						meta: {
							title: '方案设计(新)'
						},
						component: () => import('@/views/designV2/print/index.vue')
					},
					{
						path: 'singlePrint', // 列表上的打印
						name: 'designV2SinglePrint',
						meta: {
							title: '方案设计(新)',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/print/singlePrint.vue')
					},
					{
						path: 'stuLocation',
						meta: {
							title: '定位专业',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/stuLocation/index.vue')
					},
					{
						path: 'stuArchives',
						meta: {
							title: '建立档案',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/stuArchives/index.vue')
					},
          {
						path: 'printStuArchives',
						meta: {
							title: '打印档案',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/print/stuArchives.vue')
					},
          {
						path: 'printStuMajor',
						meta: {
							title: '打印专业报告',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/print/stuMajor.vue')
					},
          {
						path: 'printStuScheme',
						meta: {
							title: '打印方案',
							requiresAuth: true,
						},
						component: () => import('@/views/designV2/print/stuScheme.vue')
					},
					{
						path: 'seniorSchool', // 新高考
						meta: {
							title: '新高考'
						},
						component: () => import('@/views/designV2/seniorSchool/index.vue')
					},
				]
			},
      {
				path: '/xuanke',
				name: '高考选科',
				meta: {
					title: '高考选科'
				},
				component: xuanke
			},
			{
				path: '/xingaokao',
				name: '高考选科',
				meta: {
					title: '高考选科',
					requiresAuth: true,
				},
				component: xingaokao
			},
			{
				path: '/details',
				name: 'details',
				show: false,
				meta: {
					title: '政策资讯',
          keepAlive: true,
				},
				component: details
			},
			{
				path: '/school',
				name: 'school',
				show: false,
				meta: {
					title: '院校解读'
				},
				component: () => import('@/views/school/detail/index.vue')
			},
			{
				path: '/schoolDiff',
				name: 'schoolDiff',
				meta: {
					title: '院校对比'
				},
				component: () => import('@/views/school/diff/index.vue')
			},
			{
				path: '/Gostulocation',
				name: 'Gostulocation',
				show: false,
				meta: {
					title: '方案设计'
				},
				component: Gostulocation
			},
			{
				path: '/toProgramme',
				name: 'toProgramme',
				show: false,
				meta: {
					title: '方案设计'
				},
				component: toProgramme
			},
			{
				path: '/XkAdministration',
				name: '选科方案',
				meta: {
					title: '选科方案',
					requiresAuth: true,
				},
				component: XkAdministration
			},
			{
				path: '/newSchoolProgramme',
				name: 'newSchoolProgramme',
				meta: {
					title: '方案设计',
					requiresAuth: true,
				},
				component: newSchoolProgramme
			},
			{
				path: '/toNewSchoolProgramme',
				name: 'toNewSchoolProgramme',
				meta: {
					title: '方案设计',
					requiresAuth: true,
				},
				component: toNewSchoolProgramme
			},
			{
				path: '/XkPreview',
				name: 'XkPreview',
				meta: {
					title: '方案设计',
					requiresAuth: true,
				},
				component: XkPreview
			},
      {
        path: '/recycle',
        name: 'recycle',
        show: false,
        meta: {
          title: '回收站'
        },
        component: () => import('@/views/recycle/index.vue')
      },
      {
        path: '/collegeSubject',
        redirect: '/collegeSubject/center',
        meta: {
          title: '高考选科',
          requiresAuth: true,
          isNavbar: true,
        },
        component: () => import('@/views/router-view.vue'),
        children: [
          {
            path: 'center',
            meta: {
              title: '高考选科',
              requiresAuth: true,
            },
            component: () => import('@/views/collegeSubject/index.vue')
          },
        ]
      },

      {
        path: '/tutorialTea',
        name: 'tutorialTea',
        meta: {
          title: '操作教程',
          requiresAuth: false,
          isNavbar: true,
          reqType: '2',
          reqIsLogin: '1',
        },
        component: () => import('@/views/tutorial.vue')
      },
      {
        path: '/source',
        redirect: '/source/index',
        meta: {
          title: '资源平台',
          requiresAuth: true,
          keepAlive: true,
          isNavbar: true,
        },
        component: () => import('@/views/router-view.vue'),
        children: [
          {
            path: 'index',
            meta: {
              title: '资源平台',
              requiresAuth: true,
            },
            component: () => import('@/views/source/index.vue')
          },
        ]
      },
      {
        path: '/aiQA',
        name: 'AI 问答',
        meta: {
          title: 'AI 问答',
          requiresAuth: true,
          isNavbar: true,
          hideFooter: true,
        },
        show: true,
        component: () => import('@/views/aiQA.vue')
      },
		]
	},
]

export default routes
